import React, { createContext, FC, useState } from 'react'
import { appLocalStorage } from 'utils/misc'
import { LOCAL_STORAGE_I18N_VAR_NAME } from 'utils/constants'

export const I18nContext = createContext<any>(null)

const useI18nContext = (): any => {
  const [langCode, setLangCode] = useState(appLocalStorage.getValue(LOCAL_STORAGE_I18N_VAR_NAME))
  const changeLangCode = (value: string) => {
    setLangCode(value)
    appLocalStorage.setValue(LOCAL_STORAGE_I18N_VAR_NAME, value)
  }
  return { langCode, changeLangCode }
}

export const I18nProvider: FC = ({ children }) => {
  return <I18nContext.Provider value={useI18nContext()}>{children}</I18nContext.Provider>
}
